<template>
    <v-container class="not-found-container" fluid>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md6>
                <v-card class="not-found-card" outlined>
                    <v-card-text>
                        <v-layout align-center>
                            <v-flex xs12 md6>
                                <div class="not-found-image">
                                    <v-img src="@/assets/img/compliance-logo.svg" height="300" class="d-block"></v-img>
                                </div>
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="not-found-message">
                                    <h1 class="text-h4">Error 404</h1>
                                    <h2>La página que estás buscando no existe o no fue encontrada.</h2>
                                    <p>No te preocupes, no fue un error tuyo, pronto volveremos a estar en línea :) </p>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn to="/Dashboard" color="primary" text>
                            Volver a la página de inicio
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
  
<script>
export default {
    name: "NotFound",
};
</script>
  
<style scoped>
.not-found-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.not-found-card {
    padding: 20px;
    
}

.not-found-image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 300px;
}

.not-found-message {
    text-align: center;
}
</style>
  